import api from './httpService';

const readArray = (value: unknown): unknown[] => {
    if (Array.isArray(value)) return value;
    if (value && typeof value === "object") {
        const data = value as { data?: unknown; items?: unknown; types?: unknown };
        if (Array.isArray(data.data)) return data.data;
        if (Array.isArray(data.items)) return data.items;
        if (Array.isArray(data.types)) return data.types;
    }
    return [];
};

export const addIncomeTypeService = async (payload: Record<string, unknown>) => {
    const response = await api.post('/incomeType', payload); // assuming you're using axios
    return response.data;
};

export const getIncomeTypeService = async () => {
    const response = await api.get("/incomeType")
    return readArray(response.data);
}
export const updateIncomeTypeService = async (id: string, data: Record<string, unknown>) => {
    const response = await api.put(`/incomeType/${id}`, data); // Make sure data contains what to update
    return response.data;
};

export const addIncomeService = async (payload: Record<string, unknown>) => {
    const response = await api.post('/income', payload);
    return response.data;
};

export const getIncomeService = async (
    filters?: { startDate?: string; endDate?: string }
) => {
    const params = new URLSearchParams();
    if (filters?.startDate) params.set("startDate", filters.startDate);
    if (filters?.endDate) params.set("endDate", filters.endDate);

    const query = params.toString();
    const response = await api.get(`/income${query ? `?${query}` : ""}`);
    return readArray(response.data);
};
